import { useQuery } from "@tanstack/react-query";
import { GlobalNav } from "@centerreach/global-nav";
import type { GlobalNavSurface } from "@centerreach/global-nav";
import "@centerreach/global-nav/global-nav.css";
import { apiClient } from "../api/client";

export type WwwPortalNavBarProps = {
    surface: GlobalNavSurface;
    className?: string;
};

export function WwwPortalNavBar({ surface, className }: WwwPortalNavBarProps): JSX.Element {
    const { data: showOpinion = false } = useQuery({
        queryKey: ["todo", "navigation", "opinion"],
        queryFn: async () => {
            try {
                const { data } = await apiClient.get<{ showInGlobalNav?: boolean }>("/todo/navigation/opinion");
                return data?.showInGlobalNav === true;
            } catch {
                return false;
            }
        },
        staleTime: 5 * 60 * 1000,
        retry: false
    });

    const wwwOrigin = typeof window !== "undefined" ? window.location.origin : "https://www.centerreach.se";

    return (
        <GlobalNav
            wwwOrigin={wwwOrigin}
            surface={surface}
            showOpinionInGlobalNav={showOpinion}
            className={className}
        />
    );
}
